import { useMemo } from "react"
import { useAppSelector } from "../reducers/hooks"
import {
  selectCorrectionsFromChat,
  selectMessagesFromChat,
  selectRetractionsFromChat,
} from "../reducers/messagesSliceSelectors"
import MessageHelpers from "../lib/messageHelpers"

export const useMessageRows = (chatJid: string) => {
  // Create selectors
  const messagesSelector = useMemo(
    () => selectMessagesFromChat(chatJid),
    [chatJid],
  )
  const retractionsSelector = useMemo(
    () => selectRetractionsFromChat(chatJid),
    [chatJid],
  )
  const correctionsSelector = useMemo(
    () => selectCorrectionsFromChat(chatJid),
    [chatJid],
  )

  // Select plain messages
  const messages = useAppSelector(messagesSelector)
  const retractions = useAppSelector(retractionsSelector)
  const corrections = useAppSelector(correctionsSelector)

  const messagesWithRetractionsAndCorrections = useMemo(() => {
    return messages?.map((message) => {
      // Apply retractions
      const result = retractions?.[message.id]
        ? MessageHelpers.markRetracted(message)
        : message
      // Apply corrections
      return corrections
        ? MessageHelpers.applyCorrections(result, corrections)
        : result
    })
  }, [messages, retractions, corrections])

  return messagesWithRetractionsAndCorrections ?? []
}

export default useMessageRows
